export enum Screen {
    Mundu = '/',
    Contact = '/contact',
    Home = '/home',
    BrowseMusic = '/browse',
    Videos = '/videos',
    MusicalSurvey = '/musikalsk-kartlegging',
    MusicLibrary = '/music',
    MyClients = '/my-clients',
    NewClient = '/my-clients/new',
    NewVideo = '/new-video',
    MyCreators = '/my-creators',
    MyProfile = '/my-profile',
    Faq = '/faq',
    Tippetue = '/tippetue',
    Privacy = '/privacy',
    EULA = '/eula',
    Licences = '/licences',
    NewsPosts = '/news/',
    NewsPost = '/news/:slug',
    Admin = '/admin',
}
